import { render, staticRenderFns } from "./ReportGenPage.vue?vue&type=template&id=1fa0dd4e&scoped=true&"
import script from "./ReportGenPage.vue?vue&type=script&lang=js&"
export * from "./ReportGenPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportGenPage.vue?vue&type=style&index=0&id=1fa0dd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa0dd4e",
  null
  
)

export default component.exports